var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM19.05 13.2L8.85 19.05C8.85 19.05 8.55 19.05 8.4 19.05C8.25 19.05 8.1 19.05 7.95 19.05C7.65 18.9 7.5 18.6 7.5 18.3V6.6C7.5 6.3 7.65 6 7.95 5.85C8.25 5.7 8.55 5.7 8.85 5.85L19.05 11.7C19.35 11.85 19.5 12.15 19.5 12.45C19.5 12.75 19.35 13.05 19.05 13.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start_icon.e79d0ec91c5e4e752b316ae31e6b8778.svg";
export { ForwardRef as ReactComponent };